<template>
  <div class="bg-white relative overflow-hidden rounded-lg flex items-center justify-center">
    <div class="relative h-full flex items-center justify-center grow">
      <IconBase name="cute/spinner" class="spin" v-if="isLoading" />
      <canvas class="absolute !w-full !h-full block object-contain" :class="[ isLoading ? 'opacity-0' : 'opacity-100']" width="100%" height="100%" ref="$canvas" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import QRCode from 'qrcode'

const props = defineProps({
  content: { type: String, default: '' }
})

const { content } = toRefs(props)

const isLoading = ref(false)

const generate = async () => {
  if (!content) return

  isLoading.value = true
  
  if ($canvas.value) await QRCode.toCanvas($canvas.value, content.value, { scale: 16, margin: 4 })

  isLoading.value = false
}

const $canvas = ref()
onMounted(() => {
  isLoading.value = true
  generate()
  setTimeout(() => generate(), 500)
})

watch(content, () => generate())
</script>